var map = {
	"./background.webp": 88913,
	"./chmiel.webp": 78364,
	"./cytryna.webp": 44180,
	"./czeresnia.webp": 37231,
	"./granat.webp": 63528,
	"./jablko.webp": 63774,
	"./kapsel.webp": 64024,
	"./life-empty.svg": 90699,
	"./life-full.svg": 60343,
	"./mango.webp": 90250,
	"./truskawka.webp": 23748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43634;